/**
 * Created by dx.yang on 2017/3/2.
 */


const ksStorageRegionKey = 'region';

export const getRegion = cb => {
    __ksStorage__.getValue(ksStorageRegionKey, (k, v) => {
        cb && cb(v);
    });
};

export const setRegion = value => {
    localStorage.systemId = value;
    __ksStorage__.setValue(ksStorageRegionKey, value);

};


export const checkRegion = (regions, curRegion) => {
    let curRegionDetail = _.find(regions, ['code', curRegion]);
    if (!curRegion || !curRegionDetail) {
        let r = _.find(regions, ['isVpc', 1]);
        if (!r) {
            r = _.find(regions, (n) => {
                return n.name.toLowerCase().indexOf('vpc') != -1;
            });
        }
        if (!r) {
            r = regions[0]
        }
        curRegion = r ? r.code : '';
        curRegionDetail = r;
    }
    setRegion(curRegion);
    return {
        allRegions: regions,
        curRegion,
        curRegionDetail
    };
};


